import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { useLocaleText } from './locale'

const DotsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  gap: 8px;
`

const Dot = styled.button`
  background-color: ${props =>
    props['aria-selected'] ? '#00204d' : '#d1d1d1'};
  height: 8px;
  width: 8px;
  border-radius: 50%;
`

type CarouselDotsProps = {
  scrollSnaps: number[]
  selectedIndex: number
  onDotClick: (index: number) => void
}

export const CarouselDots: FC<CarouselDotsProps> = ({
  scrollSnaps,
  selectedIndex,
  onDotClick,
}) => {
  const t = useLocaleText()
  return (
    <DotsWrapper>
      {scrollSnaps.map((_, index) => (
        <Dot
          key={`${index + 1}`}
          onClick={() =>
            // istanbul ignore next
            onDotClick(index)
          }
          aria-selected={index === selectedIndex}
          aria-label={t('image_carousel.show_image', index)}
        />
      ))}
    </DotsWrapper>
  )
}
